<template>
    <div class="LegsFrieze__container">
        <div :class="{
            LegsFrieze__wrapper: true,
            LegsFrieze__wrapperDesktopNotMulti: legs.length <= 3 && $mq == 'desktop',
        }" :style="wrapperStyle"
        >
            <div v-if="isMultiLegs" class="LegsFrieze__item" :style="spacerStyle" />
            <div :id="`item-${index}`" class="LegsFrieze__item" v-for="(leg, index) in legs" :key="index"
                 :style="legStyle"
            >
                <div class="LegsFrieze__lineMarker">
                    <div v-if="index === 0" class="LegsFrieze__EmptyLine" />
                    <div v-else class="LegsFrieze__line">
                        <hr>
                    </div>
                    <div class="LegsFrieze__Marker preventClick">
                        <BaseIcon :class="{ 'fix-marker': littleMarker(index) }"
                                  :size="littleMarker(index) ? 'sm' : 'm'"
                        >
                            marker_new
                        </BaseIcon>
                    </div>
                    <div v-if="index === legs.length - 1 && legs.length != 1" class="LegsFrieze__EmptyLine" />
                    <div v-else class="LegsFrieze__line">
                        <span v-if="leg.time" class="LegsFrieze__time">
                            {{ leg.time }}
                        </span>
                        <hr :class="{ withArrow: !badged }">
                        <span v-if="badged" class="LegsFrieze__badge AA__badge">
                            {{ index + 1 }}
                        </span>
                    </div>
                </div>
                <span class="LegsFrieze__label" v-if="leg && typeof leg === 'string'">
                    {{ leg }}
                </span>
            </div>
            <div v-if="isMultiLegs" class="LegsFrieze__item" :style="spacerStyle" />
        </div>
        <div class="LegsFrieze__infos" v-if="withDetails">
            <div class="LegsFrieze__info">
                <BaseIcon class="mr-1" size="m">passenger_grey</BaseIcon> <span>{{ nbPassengers }}</span>
            </div>
            <div class="LegsFrieze__info">
                <BaseIcon class="mr-1" size="m">calendar_grey</BaseIcon> <span>{{ flightDates.join(' - ') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseIcon from 'webapp/components/BaseIcon';
export default {
    name: 'LegsFrieze',
    components: {
        BaseIcon,
    },
    props: {
        from: String,
        to: String,
        badged: {
            type: Boolean,
            default: false,
        },
        focus: Number,
        withDetails: {
            type: Boolean,
            default: false,
        },
        disableAirportChange: {
            type: Boolean,
            default: false,
        },
        roundTrip: {
            type: Boolean,
            default: false,
        },
        nbPassengers: {
            type: String,
            default: '1',
        },
        goneDate: {
            type: String,
            default: '',
        },
        returnDate: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            preventClick: false,
        };
    },
    computed: {
        ...mapState('searchModule', ['compute']),
        legs() {
            const result = [];
            if (this.from.trim()) result.push(this.from.trim());
            if (this.to.trim()) result.push(this.to.trim());
            if (this.roundTrip && this.from.trim()) result.push(this.from.trim());
            return result;
        },
        isMultiLegs() {
            return this.badged;
        },
        legStyle() {
            let minWidth;

            if (this.$mq !== 'desktop') {
                if (this.isMultiLegs) {
                    if (this.$vuetify.breakpoint.xsOnly) {
                        minWidth = 'calc(50% + 8px)';
                    } else {
                        minWidth = '320px';
                    }
                } else if (this.legs.length === 3) {
                    minWidth = '33.33%';
                } else {
                    minWidth = '50%';
                }
            } else {
                minWidth = '320px';
            }

            return {
                'min-width': minWidth,
            };
        },

        wrapperStyle() {
            const styles = {
                'overflow-y': this.isMultiLegs ? 'auto' : '',
                'justify-content': this.isMultiLegs
                    ? 'initial'
                    : 'justify-content',
                width: this.isMultiLegs
                    ? '100%'
                    : this.$mq === 'desktop'
                        ? this.legs.length * 320 + 'px'
                        : 'auto',
            };
            return styles;
        },

        spacerStyle() {
            if (this.legs.length * 320 > window.outerWidth) {
                return {};
            }
            return {
                // 'min-width': ((window.document.body.clientWidth / 2) - (320 / 2) - 130) + 'px',
                'min-width':
                    'calc(50vw - ' + (this.legs.length / 2) * 320 + 'px)',
            };
        },
        flightDates() {
            const formatDate = (str) => {
                const date = new Date(str);
                return isNaN(date.getTime()) ? null : `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
            };

            const dates = [formatDate(this.goneDate), formatDate(this.returnDate)].filter((d, i, arr) => d && arr.indexOf(d) === i);
            return dates;
        },
    },
    methods: {
        littleMarker(index) {
            if (!Array.isArray(this.legs) || this.legs.length === 0) return true;
            return (
                index === 0 ||
                (index === this.legs.length - 1 && this.legs.length > 2) ||
                this.badged
            );
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~webapp/styles/_variables";
@import "~webapp/styles/_typography";
@import "~webapp/styles/global";

.LegsFrieze__container {
    background-color: white;
    margin-bottom: 10px;
    box-shadow: 0px 0px 2px 2px rgba(51, 51, 51, 0.1);
    display: flex;
    flex-direction: column;
    position: relative;
    .LegsFrieze__wrapper {
        font-size: $fs-smm;
        color: $secondary;
        display: flex;
        position: relative;
        padding-top: 14px !important;
        padding-bottom: 10px !important;
        cursor: grab;

        @media (min-width: $desktop-bottom-breakpoint) {
            margin-top: 0px;
            margin-bottom: 0px;
        }

        .LegsFrieze__item {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .LegsFrieze__infos {
        display: flex;
        color: $normal-font;
        justify-content: center;
        padding-bottom: 10px !important;
        font-size: $fs-smm;
        .LegsFrieze__info {
            display: flex;
            align-items: center;
            padding: 0px 30px;
            flex-basis: 50%;
            font-weight: bold;
            color: rgba($color: #273B64, $alpha: 0.5);
            span {
                top: 2px;
                position: relative;
                font-size: 12px;
            }
        }

        :first-child {
            justify-content: end;
        }

        :last-child {
            justify-content: start;
        }
    }

    @media (min-width: $desktop-bottom-breakpoint) {
        .LegsFrieze__wrapper.LegsFrieze__wrapperDesktopNotMulti {
            width: 700px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .LegsFrieze__line-divider {
        border-width: 0px;
        border-bottom: $border dashed $primary-color;
    }

    .LegsFrieze__label {
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 $padding;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }

    .LegsFrieze__Marker {
        display: flex;
        // align-items: center;
        // justify-content: center;
        padding: 0 $padding;
        font-size: $fs-xl;

        &:not(.preventClick) {
            cursor: pointer;
        }
    }

    .LegsFrieze__lineMarker {
        display: flex;
        flex-grow: 1;
        width: 100%;

        .LegsFrieze__EmptyLine {
            flex-grow: 1;
        }

        .LegsFrieze__line {
            display: flex;
            flex-grow: 1;
            // width: 20%;
            align-items: flex-end;
            padding-bottom: 10px;
            position: relative;

            .LegsFrieze__time {
                position: absolute;
                width: 200%;
                text-align: center;
                bottom: 15px;
            }

            hr {
                flex-grow: 1;
                border-width: 0 0 1px 0;
                border-bottom: $border dotted $secondary;

                //Use this code for dash with spacing control
                // border: none;
                // height: 1px;
                // background-image: linear-gradient(to right, $primary-color 33%, rgba(255,255,255,0) 0%);
                // background-position: bottom;
                // background-size: 3px 1px;
                // background-repeat: repeat-x;
                position: relative;

                &.withArrow {
                    &::after {
                        content: "play_arrow";
                        position: absolute;
                        font-family: "Material Icons";
                        right: -7px;
                        bottom: -11px;
                    }
                }
            }
        }
    }

    .LegsFrieze__arrow-divider {
        position: relative;
        border-width: 0px;
        border-bottom: $border dashed $primary-color;

        &::after {
            color: $primary-color;
            display: flex;
            position: absolute;
            bottom: -11px;
            width: 100%;
            justify-content: center;
            content: "play_arrow";
            font-family: "Material Icons";
        }
    }

    .fix-marker {
        transform: translateY(4px);
    }

    .LegsFrieze__badge {
        position: absolute;
        right: -9px;
        bottom: 3px;
        z-index: 1;
        font-size: 10px;

        @media (max-width: 600px) {
            font-size: 8px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/LegsFrieze.vue